<template>
	<v-card flat>
		<v-container grid-list-sm fluid>
			<v-layout wrap>
				<v-flex v-for="n in 21" :key="n" xs4 sm3 d-flex child-flex>
					<v-card flat tile class="d-flex">
						<v-img
							:src="require('../assets/referencie/' + n + '.jpg')"
							:lazy-src="lazyImg"
							aspect-ratio="1"
							class="grey lighten-2"
							@click="setSelected(n)"
						>
							<template v-slot:placeholder>
								<v-layout
									fill-height
									align-center
									justify-center
									ma-0
								>
									<v-progress-circular
										indeterminate
										color="grey lighten-5"
									></v-progress-circular>
								</v-layout>
							</template>
						</v-img>
					</v-card>
				</v-flex>
			</v-layout>
		</v-container>
		<v-overlay :value="overlay" opacity="0.7">
			<v-spacer></v-spacer>
			<v-btn
				absolute
				top
				right
				fab
				color="primary"
				@click="overlay = false"
			>
				<v-icon>mdi-close</v-icon>
			</v-btn>

			<div :class="{ carusel: true, xs: $vuetify.breakpoint.xs }">
				<v-carousel hide-delimiters height="100%" :value="selected">
					<v-carousel-item
						v-for="i in 21"
						:key="i"
						:src="require('../assets/referencie/' + i + '.jpg')"
						:lazy-src="lazyImg"
						contain
					></v-carousel-item>
				</v-carousel>
			</div>
		</v-overlay>
	</v-card>
</template>

<script>
export default {
	data() {
		return {
			overlay: false,
			selected: 0,
			lazyImg: '../assets/holder8.gif'
		}
	},
	methods: {
		setSelected(n) {
			this.overlay = true
			this.selected = n - 1
		}
	}
}
</script>

<style lang="scss" scoped>
.carusel {
	position: absolute;
	margin: auto;
	max-width: 70%;
	min-width: 70%;
	height: 80%;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
}

.xs {
	max-width: 95% !important;
	min-width: 95% !important;
}

.v-btn--fab.v-size--default.v-btn--absolute.v-btn--top {
	top: 20px;
}

.v-btn--absolute.v-btn--right,
.v-btn--fixed.v-btn--right {
	right: 20px;
}
</style>
